import { Link } from "react-router-dom";
import { renderItemSinglePath, sepMoney } from "../../../../Web/Common/Function";
import { FavoriteIcon, FilledStarIcon } from "../../../component/Icons";
import style from "./style.module.scss";
import { addRemoveFavarit, getFavorite } from "../../../component/functions";
import { useState } from "react";

export default function ItemListItem({ dataList, setDataList, data, flex, classBox, link, styles }) {

  const [inFav, setInFav] = useState(false);

  const renderImage = () => {
    if (data.header_image) {
      return data.header_image;
    } else {
      return data.images && data.images[0];
    }
  };
  if (data != "seeAll") {

    return (
      <Link className={`${style.ItemListItem} my-1 ${classBox}`}
        to={`${renderItemSinglePath(
          data.category && data.category.id,
          data.city && data.city[0].slug,
          data.slug
        )}`}
        style={{ flex: flex, ...styles }} >

        <div className={style["image-container"]}>
          <img src={renderImage()} alt="" width={"100%"} />
          {data.timetable == "active" && <span className={`${style.enReserve} nfc-white nfs-9`}>رزرو فعال</span>}
          {data.off &&
            <span className={`${style.discount} nfc-white nfs-9`}>
              {`٪${Math.ceil(data.off.offpersentage)}`}
              تخفیف
            </span>
          }
          <span className={style.FavIcon} onClick={(e) => {
            e.preventDefault();
            addRemoveFavarit(data.id, inFav ? "delete" : data.is_favrite ? "delete" : "add").then(res => {
              if (dataList) {
                setDataList({ ...dataList, newGet: dataList.newGet + 1 })
              }
              else {
                setInFav(true)
              }
            });
          }}>
            <FavoriteIcon color={inFav ? "#E42A3F" : data.is_favrite ? "#E42A3F" : ""} />
          </span>
        </div>
        <div className={style["title-container"]}>
          <div className={style.title}>
            <p className="nfs-12 font-weight-bold mb-2">
              {data.name}
            </p>
            <p className="nfc-737373 nfs-10 font-weight-light ellPar">
              {data.address}
            </p>
          </div>
          <div className={style["icon-container"]}>
            <div>
              {data.gender == "both"
                ? <>
                  <img src="/img/app-home/icons-woman.png" />
                  <img src="/img/app-home/icons-man.png" />
                </>
                : data.gender == "woman"
                  ? <img src="/img/app-home/icons-woman.png" />
                  : <img src="/img/app-home/icons-man.png" />
              }

            </div>
            <div className="d-flex align-items-center justify-content-around">
              <FilledStarIcon />
              {Math.ceil(data.comments_avg_score) || 5}
            </div>
          </div>
        </div>
        <div className={style["price-container"]}>
          {/* <p className="nfc-E42A3F nfs-12 text-decoration-line-through">{`${sepMoney(
          200000
        )} تومان`}</p> */}
          <p className="nfc-1BA462 nfs-12">
            {data.header_price
              ? `شروع قیمت از: ${sepMoney(data.header_price)} تومان`
              : 'قیمت ثبت نشده'
            }
          </p>
        </div>
      </Link >
    );
  }
  return (
    <Link className={`${style.ItemListItem} my-1 ${classBox}`} to={link} style={{ flex: flex }} >

      مشاهده همه
    </Link>
  );
}
